import apiClient from '../apiClient';
import { POST_SUPPLIER_URL } from '../apiUrl';

const postSupplierApi = data => {
  return apiClient.post(POST_SUPPLIER_URL, data);
};

export default postSupplierApi;
